module.exports = __webpack_public_path__ + "img/wxgzhNew.2db0d22e.jpg";